import React, { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { onyxArtworkLayers } from './onyxArtworkLayers';
import './onyxDestinationArtwork.css';

const preload = (src) => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => image.decode ? image.decode().then(resolve, reject) : resolve();
  image.onerror = reject;
  image.src = src;
});

export const OnyxDestinationArtwork = ({ id, fallback }) => {
  const reduceMotion = useReducedMotion();
  const artwork = onyxArtworkLayers[id];
  const dimensions = { width: artwork.width || 768, height: artwork.height || 768 };
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    setReady(false); setFailed(false);
    if (!reduceMotion) {
      Promise.all([artwork.base, ...artwork.layers.map((layer) => layer.src)].map(preload))
        .then(() => { if (active) setReady(true); })
        .catch(() => { if (active) setFailed(true); });
    }
    return () => { active = false; };
  }, [artwork, reduceMotion]);
  const animated = ready && !failed && !reduceMotion;
  const mask = artwork.sheen ? `url(/home-card-motion/onyx/${artwork.sheen}.webp)` : undefined;
  return <span className="onyx-artwork" aria-hidden="true" data-testid={`onyx-artwork-${id}`} data-motion-ready={animated} data-motion-error={failed}>
    <img className="onyx-artwork-fallback" src={fallback} alt="" {...dimensions} decoding="async" draggable="false" data-testid={`trial-artwork-${id}`} />
    {animated && <span className="onyx-artwork-stage" data-testid={`onyx-stage-${id}`}>
      <img className="onyx-artwork-base" src={artwork.base} alt="" {...dimensions} draggable="false" onError={() => setFailed(true)} data-testid={`onyx-base-${id}`} />
      {artwork.layers.map((layer) => <img key={layer.name} className={`onyx-artwork-layer ${layer.className}`} src={layer.src} alt="" {...dimensions} draggable="false" onError={() => setFailed(true)} data-testid={`onyx-${id}-${layer.name}`} />)}
      {mask && <span className="onyx-object-sheen" style={{ maskImage: mask, WebkitMaskImage: mask }} data-testid={`onyx-${id}-shine`} />}
    </span>}
  </span>;
};